import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Grid, Link, Paper, Switch, Typography, Box, Accordion, AccordionSummary, AccordionDetails, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useSnackbar } from 'notistack';
import { eventToggleApi, getAlertListApi, getUserApi, mailTemplateApi, updateUserApi } from '../apiService';
import MailConfigurationModal from '../components/MailConfigurationModal';
import "../../assets/styles/_alert_notifications.scss"
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { PageLoader, STableLoader } from '../../../shared_elements';
import AlertTabs from '../components/AlertTabs';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { trackActivity } from '../../../utils/mixpanel';
import CustomAlerts from './customAlerts';
import ExpiryAlerts from './ExpiryAlerts';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { PermissionWrapper } from '../../../wrappers';

const AlertNotification = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { leaseBasicDetails, permission } = useSelector((state) => state.leases);
  const alertPermission = permission?.permissions?.lease_revamp_application?.lease_revamp?.alert_n_notification;
  const hasAlertEditPermission = Array.isArray(alertPermission) ? alertPermission.includes('U') : false;
  const [mailConfig, setMailConfig] = useState({ modal: false, })
  const [alertInfo, setAlertInfo] = useState([])
  const [userInfo, setUserInfo] = useState([])
  const [isLoading, setLoading] = useState({ skeletonLoader: true, buttonLoader: false, pageLoader: false });
  const [dropDownLoader, setDropDownLoader] = useState(false)
  const [mailData, setMailData] = useState({})
  const [error, setError] = useState(false)
  const [activeTab, setActiveTab] = useState("event");
  const [compactActionBar, setCompactActionBar] = useState(null);
  const operationObj = {
    "create": "C",
    "update": "U",
    "delete": "D",
    "export": "EXP"
  }
  const onFieldChange = (key, value) => { setMailData({ ...mailData, [key]: value }); };
  const onFocusChange = (keyParam) => { setError({ ...error, [keyParam]: '' }) }
  const getAlertList = (loaderType) => {
    loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: true }) : setLoading({ pageLoader: true });
    if (leaseBasicDetails?.id) {
      globalGetService(getAlertListApi(leaseBasicDetails?.id)).then(response => {
        if (checkApiStatus(response)) {
          loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: false }) : setLoading({ pageLoader: false });
          setAlertInfo(response.data.data);
        } else {
          loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: false }) : setLoading({ pageLoader: false });
        }
      })
    }
  };
  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Alert & Notifications' })
  }, [])
  useEffect(() => {
    if (!leaseBasicDetails?.status) return;
    getAlertList("skeletonLoader");
  }, [leaseBasicDetails?.status])

  const getUserList = (moduleKey, operatioKey) => {
    setDropDownLoader(true)
    globalGetService(getUserApi(moduleKey, operationObj[operatioKey])).then(response => {
      setDropDownLoader(false)
      if (checkApiStatus(response)) {
        setUserInfo(response.data.data)
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
      }
    })
  }
  const getMailTemplate = (eventId) => {
    setLoading({ pageLoader: true })
    globalGetService(mailTemplateApi(eventId)).then(response => {
      setLoading({ pageLoader: false })
      if (checkApiStatus(response)) {
        setMailData({ ...mailData, subject: response?.data?.data?.subject, body: response?.data?.data?.body })
      }
    })
  };
  const onEditUser = (eventId) => {
    const payload = { user_ids: mailData?.user_ids?.map(user => user?.user_id && Number(user.user_id)), lease_id: leaseBasicDetails?.id }
    const validationInputs = {
      user_ids: mailConfig.mode === "addUser" && (!mailData?.user_ids || mailData?.user_ids?.length <= 0) ? "Please select User(s)" : ""
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading({ buttonLoader: true })
      globalPutService(updateUserApi(eventId), payload).then(response => {
        setLoading({ buttonLoader: false })
        if (checkApiStatus(response)) {
          onToggleModal()
          getAlertList("pageLoader")
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Users`, success_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Users`, error_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
        }
      })
    } else {
      setError(validationInputs);
    }
  };
  const onEditMailTemplate = (eventId) => {
    setLoading({ buttonLoader: true })
    const payload = { subject: mailData?.subject, body: mailData?.body, lease_id: leaseBasicDetails?.id }
    globalPutService(mailTemplateApi(eventId), payload).then(response => {
      setLoading({ buttonLoader: false })
      if (checkApiStatus(response)) {
        onToggleModal()
        getAlertList("pageLoader")
        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Mail Template`, success_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Mail Template`, error_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
      }
    })
  };
  const onToggleModal = () => { setMailConfig({ data: null, modal: false, mode: null, checked: false, mailTemplateId: null, eventTypeId: null, moduleKey: null, operatioKey: null }); setUserInfo(null); setMailData({}); setError({}) }
  const onEventToggle = (status, eventTypeId) => {
    const validationInputs = {
      user_ids: mailConfig.mode === "enable" && (!mailData?.user_ids || mailData?.user_ids?.length <= 0) ? "Please select User(s)" : ""
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      status ? setLoading({ buttonLoader: true }) : setLoading({ pageLoader: true })
      const payload = status ? { ...mailData, lease_id: leaseBasicDetails?.id, enabled: true, user_ids: mailData?.user_ids?.map(user => user.user_id) } : {lease_id: leaseBasicDetails?.id, enabled: false };
      globalPutService(eventToggleApi(eventTypeId), payload).then((response) => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          getAlertList("pageLoader")
          onToggleModal()
          trackActivity('Item Edited', { page_title: `${status ? 'Enable' : 'Disable'} Alert Event`, success_msg: response?.data?.message, item_id: eventTypeId, payload, response: response?.data })
        } else {
          setLoading({ ...isLoading, buttonLoader: false, pageLoader: false })
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `${status ? 'Enable' : 'Disable'} Alert Event`, error_msg: response?.data?.message, item_id: eventTypeId, payload, response: response?.data })
        }
      });
    } else {
      setError(validationInputs);
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Alert & Notifications`, page_type: page_type, })
  }
  const onChangeTab = (value) => {
    setActiveTab(value);
    setCompactActionBar(null);
    handleItemClicked(`Clicked on ${value === 'event' ? 'Event' : value === 'expiry' ? 'Expiry' : 'Custom'} Alert(s) tab`)
  }

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
        <div className='lease-details-content'>
          <Paper square className="responsive-paper">
            <Grid container rowSpacing={0} columnSpacing={1} className="responsive-grid" alignItems='flex-end'>
              <Grid size={{ md: 12 }}>
                <AlertTabs value={activeTab} onChangeTab={(e, value) => onChangeTab(value)} />
              </Grid>
              <Grid item size={{ md: 4, xs: 12 }} className="menu-container lease-list-link-mt">
                <BackToLeaseList/>
              </Grid>
              {compactActionBar && (
                <Grid item size={{ md: 8, xs: 12 }}>
                  {compactActionBar}
                </Grid>
              )}
            </Grid>
          </Paper>
          {activeTab === "event" && (
            <>
            <Paper className='alert-notification-container' elevation={0} sx={{ boxShadow: "0px 0px 1px 1px #BBBBBB" }}>
              {isLoading?.skeletonLoader ? (<STableLoader count={4} rowCount={10} />) : alertInfo?.length > 0 ? alertInfo?.map((moduleItem, index) => {
                return (
                  <>
                    <Accordion elevation={4} square>
                      <AccordionSummary slotProps={{
                        content: {
                          sx: {
                            '&.Mui-expanded': {
                              margin: '10px 0',
                            },
                          },
                        },
                      }} expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                        <Typography className='alert-notification-title' color='primary'>{moduleItem?.name}</Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: '0px', marginBottom: '15px' }}>
                        <Grid container marginLeft={2} marginRight={2}>
                          <Table className="mui-table-format" stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell align="left" sx={{ width: "140px" }}>Event</TableCell>
                                <TableCell align="center" sx={{ width: "140px" }}>Enable / Disable</TableCell>
                                <TableCell align="left" sx={{ width: "140px" }}>Notify User(s)</TableCell>
                                <TableCell align="left" sx={{ width: "140px" }}>Mail Template</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {moduleItem?.event_types?.map((item) => (
                                <TableRow key={item?.id} className="alert-notification-body">
                                  <TableCell> {item?.name} </TableCell>
                                  <TableCell align="center">
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "alert_n_notification", operationType: ['C', 'U'] }}
                                      noPermissionChild={
                                        <Switch size="small" checked={item?.enabled} disabled />
                                      }>
                                      <Switch
                                        size="small"
                                        checked={item?.enabled}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setMailConfig({
                                              modal: true,
                                              eventTypeId: item?.id,
                                              moduleKey: moduleItem?.module_key,
                                              operatioKey: item?.operation_key,
                                              mode: "enable",
                                              checked: true,
                                            });
                                            getUserList(
                                              moduleItem?.module_key,
                                              item?.operation_key
                                            );
                                            handleItemClicked(`${item?.name || ""} Enable Switch`)
                                          } else {
                                            onEventToggle(false, item?.id);
                                            handleItemClicked(`${item?.name || ""} Disable Switch`)
                                          }
                                        }}
                                      />
                                    </PermissionWrapper>
                                  </TableCell>
                                  <TableCell>
                                    {item?.enabled &&
                                      <Box sx={{ opacity: 1, cursor: "pointer", }} >
                                        <Link
                                          sx={{ pointerEvents: "auto" }}
                                          onClick={() => {
                                            setMailConfig({
                                              modal: true,
                                              eventTypeId: item?.id,
                                              mode: "addUser",
                                              moduleKey: moduleItem?.module_key,
                                              operatioKey: item?.operation_key,
                                            });
                                            setMailData({
                                              ...mailData,
                                              user_ids: item?.notify_users,
                                            });
                                            getUserList(
                                              moduleItem?.module_key,
                                              item?.operation_key
                                            );
                                            handleItemClicked(`${item?.name || ""} ${item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} User(s)`)
                                          }}
                                        >
                                          {item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} User(s)
                                        </Link>
                                        {item?.enabled && item?.notify_users?.length > 0 && (<sup style={{ fontSize: "10px" }}> ({item.notify_users.length}) </sup>)}
                                      </Box>}
                                  </TableCell>
                                  <TableCell>
                                    {item?.enabled &&
                                      <Box sx={{ opacity: 1, cursor: "pointer", }} >
                                        <Link
                                          sx={{ pointerEvents: "auto" }}
                                          onClick={() => {
                                            setMailConfig({
                                              modal: true,
                                              eventTypeId: item?.id,
                                              mailTemplateId: item?.mail_template?.id,
                                              mode: "addTemplate",
                                            });
                                            getMailTemplate(item?.mail_template?.id);
                                            handleItemClicked(`${item?.name || ""} ${item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Mail Template`)
                                          }}
                                        >
                                          {item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Mail Template
                                        </Link>
                                      </Box>}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </>
                )
              }) : <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", fontSize: "20px", fontWeight: "bold" }}>No Record Found</Typography>}
            </Paper>
            </>)}
          {activeTab === "expiry" && (
            <ExpiryAlerts setActionBar={setCompactActionBar} />
          )}

          {activeTab === "custom" && (
            <CustomAlerts setActionBar={setCompactActionBar} />
          )}
        </div>}
        {mailConfig?.modal ? <MailConfigurationModal isLoading={isLoading} mailConfig={mailConfig} mailData={mailData} userInfo={userInfo} dropDownLoader={dropDownLoader} error={error} onEventToggle={onEventToggle} onEditUser={onEditUser} onEditMailTemplate={onEditMailTemplate} onFieldChange={onFieldChange} onFocusChange={onFocusChange} onToggleModal={onToggleModal} disableFields={!hasAlertEditPermission} /> : null}
      </Paper>
      {isLoading?.pageLoader ? <PageLoader /> : null}
    </>
  )
}

export default AlertNotification;